<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Pronto Atendimento</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="2" :class="espacamentoMobile" v-show="clickSwitch">
      <div align="left" style="font-size: 15px; padding-top: 8px">
        Quais são as especialidades oferecidas?
      </div>
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile" v-show="clickSwitch">
      <unicom-campo-texto
        ladoIcone="direito"
        clickIcone
        colorPlaceholder="#9E9E9E"
        :maxCaracteres="1500"
        placeholder="Especialidades Oferecidas"
        v-model="payload.especialidadesOferecidas"
      />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile"></unicom-coluna>
    <unicom-coluna sm="3" :class="espacamentoMobile"></unicom-coluna>

    <unicom-coluna sm="2" :class="espacamentoMobile" v-show="clickSwitch">
      <div align="left" style="font-size: 15px; padding-top: 20px">
        Número de Leitos de Observação?
      </div>
    </unicom-coluna>

    <unicom-coluna
      sm="4"
      :class="espacamentoMobile"
      v-show="clickSwitch"
      style="padding-top: 20px"
    >
      <custom-campo-texto
        ladoIcone="direito"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Número de Leitos"
        :apenasNumero="true"
        v-model="payload.numeroLeitosObservacao"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    CustomCampoTexto
  },
  data() {
    return {
      payload: {
        tipoServico: "Pronto Atendimento",
        tipoServicoPublico: [],
        especialidadesOferecidas: "",
        numeroLeitosObservacao: ""
      }
    };
  },
  watch: {
    "payload.numeroLeitosObservacao": "emitir",
    "payload.especialidadesOferecidas": "emitir",
    "payload.tipoServicoPublico": `emitir`,
    dadosServidor(newVal) {
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico ||
              servico.especialidadesOferecidas ||
              servico.numeroLeitosObservacao)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.preencheCampo("leitos", servico.numeroLeitosObservacao);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: left;
}
</style>
